import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from '@common/utils/auth/AuthContext';
import { HelmetProvider } from 'react-helmet-async';

// if (process.env.NODE_ENV !== 'development') {
//   console.log = function () { };
//   console.debug = function () { };
//   console.info = function () { };
//   console.warn = function () { };
//   console.error = function () { };
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
